import { PosIconProps, SvgWrapper } from './SvgWrapper';

export const ErrorOverlayIcon = ({
  noOutline,
  ...props
}: Omit<PosIconProps, 'viewBox'> & { noOutline?: boolean }) => {
  return (
    <SvgWrapper {...props} viewBox="0 0 20 20" fill="none">
      <circle cx="15" cy="5" r="5" fill="red" />
    </SvgWrapper>
  );
};
